/**
 * Resolve a node's display label.
 *
 * @param node     anything with optional `label` / `labelKey`
 * @param intl     react-intl IntlShape (`useIntl()` result)
 * @param fallback optional last-resort string for nodes lacking both keys
 */
export var resolveLabel = function (node, intl, fallback) {
    var _a, _b;
    if (node.label !== undefined && node.label !== null) {
        // Multi-language shape: prefer cs (project language), fall back to en.
        var raw = typeof node.label === 'string'
            ? node.label
            : ((_b = (_a = node.label.cs) !== null && _a !== void 0 ? _a : node.label.en) !== null && _b !== void 0 ? _b : '');
        var trimmed = raw.trim();
        if (trimmed.length > 0)
            return trimmed;
        // Empty / whitespace-only inline label — fall through to labelKey so a
        // partial config (e.g. `{ label: '', labelKey: 'x.foo' }`) still shows
        // the legacy translation rather than rendering as blank.
    }
    if (node.labelKey) {
        return intl.formatMessage({ id: node.labelKey });
    }
    return fallback !== null && fallback !== void 0 ? fallback : '';
};
